import { saveAs } from 'file-saver'

// 正常通知
export function notifySuccess(vue, title, message) {
  if (vue.loading) {
    vue.loading = false;
  } 
  vue.$notify({
    title: title || '成功',
    message: message || '成功しました。',
    type: 'success',
    dangerouslyUseHTMLString: true
  });
}

// ワーニング通知
export function notifyWarning(vue, title, message) {
  if (vue.loading) {
    vue.loading = false;
  } 
  vue.$notify({
    title: title || '警告',
    message: message || '警告があります。',
    type: 'warning',
    dangerouslyUseHTMLString: true
  });
}

// エラー通知
export function notifyError(vue, error, title, message, isK) {
  if (vue.loading) {
    vue.loading = false;
  } 
  if (error?.response?.status == '401' || error?.response?.status == '408') {
    let parent = vue.$parent;
    if (parent.disableMenu == undefined) {
      parent = parent.$parent;
    }
    parent.disableMenu();
    if (isK) {
      parent.switchMenu('ErrorPageK', '/errorPage');
    } else {
      parent.switchMenu('ErrorPage', '/errorPage');
    }
  } else {
    vue.$notify({
      title: title || 'エラー',
      message: message || error?.message || error?.response?.statusText || 'エラー',
      type: 'error',
      dangerouslyUseHTMLString: true
    });
  }
}

// ダウンロードファイル名取得
export function downloadFile(vue, response) {
  if (vue.loading) {
    vue.loading = false;
  } 
  const blob = new Blob([response.data], {
    type: response.data.type
  });
  // レスポンスヘッダからファイル名を取得
  const contentDisposition = response.headers["content-disposition"];
  let fileName = contentDisposition.substring(
    contentDisposition.indexOf("''") + 2, contentDisposition.length);
  // デコードするとスペースが"+"になるのでスペースへ置換
  fileName = decodeURI(fileName).replace(/\+/g, " ");
  // ダウンロード
  saveAs(blob, fileName);
}
